import cx from 'classnames';

import Text from '../Text';
import styles from './Pill.module.css';

import { forwardRef } from 'react';

export interface PillProps {
  className?: string;
  leftIcon?: React.ReactNode;
  text: string;
  textClassName?: string;
  rightSlot?: React.ReactNode;
  onClick?: () => void;
}

export default forwardRef(function Pill(
  {
    className,
    leftIcon,
    rightSlot,
    text,
    textClassName,
    ...otherProps
  }: PillProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  const textLeftMargin = leftIcon ? '4' : '8';
  const textRightMargin = rightSlot ? '4' : '8';

  return (
    <button
      ref={ref}
      type="button"
      className={cx(styles['base'], className)}
      {...otherProps}
    >
      {leftIcon && <span className={styles['left-icon']}>{leftIcon}</span>}
      <Text
        ml={textLeftMargin}
        mr={textRightMargin}
        size="small"
        weight="600"
        color="inherit"
        className={cx(styles['text'], textClassName)}
      >
        {text}
      </Text>
      {rightSlot}
    </button>
  );
});
